module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_books_4b591cf6d3d009582708bb92a315d5bd.png";